import { generateUrl, getLocale, isValidLocale } from './Locales';

/**
 * Updates the current route if it is incorrect based on the new language
 * Runs when the i18n `languageChanged` callback is triggered through Language Detection & NOT the LocalePicker
 *
 * @param {string} lng - the language i18n is updating to
 */
export function redirectOnI18nLanguageChange(lng: string): void {
  const isLanguageSupportedByNADataCenter = isValidLocale(lng);

  if (!isLanguageSupportedByNADataCenter) {
    const linkToSupportedDataCenterOrNAHomePage = generateUrl(getLocale(lng));
    window.location.assign(linkToSupportedDataCenterOrNAHomePage);
  }
}
